import { request } from './shared';

/**
 * Log what the user is typing in the Insurance Plan search box.
 * @param {string} searchInput
 * @returns {Promise}
 */

export function logPlanSearch(searchInput) {
  return request({
    url: '/log_plan_search',
    method: 'POST',
    data: { searchInput },
  });
}
